// extracted by mini-css-extract-plugin
export default {"loader":"f0dbMn"};